import { createElement, Fragment } from 'react';
// cjs module
import { default as unified } from 'unified';
import remarkParse from 'remark-parse';
import remark2rehype from 'remark-rehype';
// If you need to support HTML tags, remember to sanitize the output
// https://github.com/remarkjs/remark-rehype#example-supporting-html-in-markdown-properly
import rehypeSanitize from 'rehype-sanitize';
import rehypeReact from 'rehype-react';

const createProcessor = (components = {}) => {
  return unified()
    .use(remarkParse)
    .use(remark2rehype)
    .use(rehypeSanitize)
    .use(rehypeReact, {
      createElement,
      Fragment,
      components,
    });
};

// Building the unified pipeline is not free: each `use()` registers a plugin and the
// first `processSync` freezes and compiles the whole chain. That was happening once
// per markdown field per render, even though the pipeline depends only on the
// `components` mapping — which is a module-level constant in Field.js, so it is the
// same object every time. Caching the processor per components mapping turns N
// pipeline constructions into one. A WeakMap is used so a caller passing a
// short-lived components object doesn't leak.
const processorCache = new WeakMap();
let defaultProcessor = null;

const getProcessor = components => {
  if (!components) {
    defaultProcessor = defaultProcessor || createProcessor();
    return defaultProcessor;
  }
  let cached = processorCache.get(components);
  if (!cached) {
    cached = createProcessor(components);
    processorCache.set(components, cached);
  }
  return cached;
};

const renderMarkdown = (markdownText, components) => {
  return getProcessor(components).processSync(markdownText).result;
};
export default renderMarkdown;
